/**
 * Stories for DashboardPageLayout handle this component
 */
// eslint-disable-next-line local-rules/require-storybook-documentation
import React, { ReactNode, HTMLAttributes } from 'react';
import { Card, Box } from '@zillow/constellation-10';
import { FunctionComponentWithChildren } from 'src/utils/types';

interface GhostCardProps extends HTMLAttributes<HTMLDivElement> {
    top?: boolean;
    bottom?: boolean;
}

/**
 * GhostCard component provides a simple container with optional top and bottom borders
 * Stories implemented in DashboardPageLayout
 */
// eslint-disable-next-line local-rules/require-storybook-documentation
export const GhostCard: FunctionComponentWithChildren<GhostCardProps> = ({
    top = true,
    bottom,
    children,
    ...props
}) => (
    <Box
        css={{
            width: '100%',
            paddingTop: 'lg',
            paddingBottom: 'xl',
            borderLeft: 0,
            borderRight: 0,
            borderRadius: 0,
            boxShadow: 'none',
            borderTop: top ? '1px solid' : 'none',
            borderBottom: bottom ? '1px solid' : 'none',
            borderColor: 'var(--colors-gray-300)',
        }}
        {...props}>
        {children}
    </Box>
);

interface MobileGhostCardDesktopCardProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
}

export const MobileGhostCardDesktopCard = (props: MobileGhostCardDesktopCardProps) => (
    <>
        <Card tone="neutral" elevated={false} css={{ display: { base: 'none', md: 'block' } }} {...props}>
            {props.children}
        </Card>
        <Box css={{ display: { base: 'block', md: 'none' }, paddingTop: 'lg', paddingBottom: 'lg' }} {...props}>
            {props.children}
        </Box>
    </>
);
